(function(){
    angular
        .module('app')
        .directive('ngSelect2alt', select2);

        select2.$inject = ['$timeout','batchselect2AltService'];
        function select2($timeout,batchselect2AltService){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"=",
                valorrel:"=",
                extras: "=",
                extraparams : "=",
                control: "=",
                removesearcher : "="
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {

                  function format(icon) {
                    var originalOption = icon.element;
                      var str = "";
                      if(typeof $(originalOption).data('icon') != 'undefined'){
                        str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
                        return $(str+" ");
                      }else{
                        return icon.text || icon.value;
                      }
                  }

                  //console.log("select2 ",$attrs.name);
                  var options = {
                  };
                  if(!scope.options){
                     if($attrs.campos!=''){
                      //console.log(scope.extraparams);
                      options = {
                        ajax: {
                          url: "/backend/altcrm/content/select2",
                          dataType: 'json',
                          delay: 250,
                          processResults: function (data, params) {
                            // parse the results into the format expected by Select2
                            // since we are using custom formatting functions we do not need to
                            // alter the remote JSON data, except to indicate that infinite
                            // scrolling can be used
                            params.page = params.page || 1;
                            return {
                              results: data.items,
                              pagination: {
                                more: (params.page * 1) < data.total_count
                              }
                            };
                          }
                        },
                        templateSelection: format,
                        templateResult: format
                      };
                      options.ajax.data = function (params) {
                            return {
                              q: params.term, // search term
                              page: params.page,
                              valorrel : scope.valorrel,
                              camporel : $attrs.camporel,
                              ordenrel : $attrs.ordenrel,
                              field: $attrs.campos,
                              field_name: $attrs.fieldactual,
                              per_page: 20,
                              nodetype:$attrs.nodetype,
                              nodetype_actual:$attrs.typeactual
                            };
                          }
                        }
                  }else{
                    options = angular.copy(scope.options);
                    //console.log(scope);
                    if(scope.extraparams){
                      var datavar = options.ajax.data({});
                      //console.log(scope.extraparams);
                      options.ajax.data = function(params){
                        datavar.q = params.term;
                        datavar.page = params.page;
                        if($attrs.campos){
                          datavar.field = $attrs.campos;
                        }
                        var objectMerge = angular.merge({}, datavar, scope.extraparams);
                        return objectMerge;
                      }
                    }
                  }
                  //console.log(options);
                  var $element = $(element);
                  if(scope.removesearcher===true){
                    options.minimumResultsForSearch = -1;
                  }

                  //console.log("options",options);
                  $element.select2(options);//.val([{"id":"10","text":"value"}]).trigger("change");

                  //console.log(ngModel.$viewValue);
                  /*if($attrs.nodetype && ngModel.$viewValue!='' && typeof(ngModel.$viewValue) != 'undefined' && ngModel.$viewValue!=0){
                    //$element.select2("data", { id: ngModel.$viewValue, text:'Cargando..' });

                    var valor = ngModel.$viewValue;
                    if(Array.isArray(valor)){
                      var $newOption = $("<option selected='selected'></option>").val(valor[0]).text("Cargando..");
                    }else{
                      var $newOption = $("<option selected='selected'></option>").val(valor).text("Cargando..");
                    }
                    //var $newOption = $("<option selected='selected'></option>").val(valor[0]).text("Cargando..");
                    $element.append($newOption).trigger('change.select2');
                    $.get('/backend/altcrm/content/getvalueselect2',{campo:$attrs.campos,nodetype:$attrs.nodetype,value:valor},function(data){
                      //console.log(data);
                      for(var cont=0;cont<data.length;cont++){
                        //var $newOption = $("<option selected='selected'></option>").val(data[cont].id).text(data[cont].text);
                        if(cont==0){
                          $element.find("option[value='"+data[cont].id+"']").text(data[cont].text);
                        
                        }else{
                          $element.select2("trigger", "select", {
                              data: { id: data[cont].id, text:data[cont].text }
                          })
                        }
                        
                      }    
                      $element.select2(options).trigger('change.select2');
                    },"json");
                  }*/

                    
                    
                    $element.on("select2:open", function (evt) {
                        console.log("select2open");
                      
                      $timeout(function(){
                         document.querySelector('.select2-container--open .select2-search__field').focus();
                      });

                      //self.$search.attr('tabindex', 0);
                      //self.$search.focus(); remove this line
                      //setTimeout(function () { self.$search.focus(); }, 10);//add this line

                    });
                    /*$element.on("change.select2", function (evt) {
                     // console.log("select2:select");
                    });*/
                    $element.on("change", function (evt) {
                     // console.log("changesingle");
                      console.log("CHANGE");
                      //ngModel.$setViewValue($element.val());
                    })
                    $element.on("select2:select", function (evt) {
                     // console.log("select2:select ");
                        var elementVar = evt.params.data.element;
                        var $elementVar = $(elementVar);
                        //console.log($element.val());
                        ngModel.$setViewValue($element.val());
                        //console.log(ngModel);
                        /*alert($element.val());
                        $elementVar.detach();
                        $(this).append($elementVar);
                        $(this).trigger("change");*/
                      });

                    function orderSortedValues() {
                        var value = ''
                        $element.parent().find("ul.select2-selection__rendered").children("li[title]").each(function(i, obj){

                            var elM = $element.children('option').filter(function () { return $(this).html() == obj.title });
                            moveElementToEndOfParent(elM)
                        });
                    };
                   function moveElementToEndOfParent(elM) {
                        var parent = elM.parent();
                        elM.detach();
                        parent.append(elM);
                    };

                    function actualizarElementos(){
                     
                        if(typeof $attrs.multiple!='undefined'){
                          var ul = $element.parent().find("ul.select2-selection__rendered");
                          ul.sortable({
                              placeholder : 'ui-state-highlight',
                              items: '> li.select2-selection__choice',
                              tolerance   : 'pointer',
                              update: function() {
                                console.log("E");
                                orderSortedValues();
                                  /*$(ul.find('.select2-selection__choice').get().reverse()).each(function() { 
                                      var id = $(this).data('data').id;
                                      var option = $element.find('option[value="' + id + '"]')[0];
                                      $($element).prepend(option);
                                      //$element.trigger("change");
                                  });*/
                                  $element.trigger("change");
                              }
                          });
                        }
                    }

                    function cambiando(){
                     // console.log("CAMBIANDO");
                      //console.log($element);
                      //console.log(scope.ngModel);
                      //console.log(ngModel.$viewValue);
                      if(scope.ngModel==""){
                        //console.log("cambiando");
                        $element.trigger('change.select2');
                      }else{
                        var texto = $element.find("option:selected").text();
                          //console.log("viewvalue",ngModel.$viewValue);
                        if(!texto && scope.ngModel && $attrs.campos){
                          
                          //console.log("viewvalue",ngModel.$viewValue);
                          if(Array.isArray(ngModel.$viewValue)){
                            for(var cont=0;cont<ngModel.$viewValue.length;cont++){
                              if(ngModel.$viewValue[cont]!=0){
                                var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue[cont]).text("Cargando..");
                                $element.append($newOption).trigger('change.select2');
                              }
                            }
                          }else{
                             if(ngModel.$viewValue!=0){
                               var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue).text("Cargando..");
                               $element.append($newOption).trigger('change.select2');
                             }
                          }
                          if(scope.ngModel!=0){
                            
                              var objReq = { campo:$attrs.campos,nodetype:$attrs.nodetype,value:scope.ngModel}
                              batchselect2AltService.addId(objReq).then(function(data) {
                                //console.log("ENTRO A LA PETI");
                                  for(var cont=0;cont<data.length;cont++){
                                    //console.log("data",data);
                                    //console.log("scope.ngModel",scope.ngModel);
                                    if($attrs.nodetype==data[cont].nodetype && $attrs.campos==data[cont].campo){
                                      
                                      $element.find("option[value='"+data[cont].id+"']").text(data[cont].text);
                                      //console.log("ENTRO ACTUALIZANDO");
                                    }
                                  }
                                  actualizarElementos();
                                  $element.select2(options).trigger('change.select2');
                              }, function(error) {
                                  console.error('Error obteniendo datos:', error);
                              });
                              
                              

                          }
                        }else{
                          
                          actualizarElementos();
                        }
                        

                        //$element.trigger('change.select2');
                      }
                    }
                    /*$(element).select2("trigger", "select", {
                        data: { id: ngModel.$viewValue, text:ngModel.$viewValue}
                    },500);*/
                    cambiando();
                    scope.$watch('ngModel', cambiando, true);



                     console.log("LIST");
                 
                });
            }
          }
      }
})();